import { ErrorType, MappedError } from "./interfaces";
import { InlineP, StyledA, StyledLi, StyledUl } from "./styled";

import React from "react";

interface Props {
  errorArray: MappedError[];
  type: ErrorType;
}

export const ErrorList = ({ errorArray, type }: Props): React.ReactElement => {
  return (
    <StyledUl>
      {errorArray
        .filter((error) => error.type === type)
        .map((error) => (
          <StyledLi key={error.id}>
            <StyledA href={"#" + error.id}>{error.errorLabel + ": "}</StyledA>
            <InlineP>{error.errorMessage}</InlineP>
          </StyledLi>
        ))}
    </StyledUl>
  );
};
